//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vClickOutside from 'v-click-outside'
import SingleLoading from '~/components/partials/loading/single_loading'
export default {
  name: 'CoinSearch',
  components: { SingleLoading },
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: {
    mobile: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      search: null,
      timer: 1,
      interval: null,
      showSearch: false,
      loading: false
    }
  },
  watch: {
    timer (val) {
      if (val === 0) {
        this.$axios.get('https://www.arzypto.com/capi/search', {
          params: { q: this.search }
        }).then((res) => {
          this.$store.commit('coins/set_data', {
            stateName: 'coinsSearched',
            data: res.data.data
          })
          this.loading = false
        }).catch((e) => {
          this.loading = false
        })
        clearInterval(this.interval)
        this.timer = 1
      }
    },
    showSearch (val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.search.focus()
        })
      }
    },
    mobile (val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.search.focus()
        })
      }
    },
    search (val) {
      if (val) {
        this.loading = true
      }
    }
  },
  mounted () {
    this.$root.$on('openSearch', () => {
      this.showSearch = true
      this.$refs.coinSearch.scrollIntoView({
        behavior: 'smooth'
      })
    })
  },
  methods: {
    hidden () {
      if (!this.mobile) {
        this.showSearch = false
      }
    },
    checkSearch (evt) {
      if (this.interval) {
        clearInterval(this.interval)
      }
      this.timer = 1
      if (evt.target.value === '') {
        this.$store.commit('coins/set_data', { stateName: 'coinsSearched', data: [] })
      } else {
        this.interval = setInterval(() => {
          this.timer -= 1
        }, 1000)
      }
    }
  }
}
